module.exports = __webpack_public_path__ + "img/c00_buildingtechfortifiedtower_Normal_ua.7f91d220.webp";